export default __webpack_public_path__ + "static/media/man.18c9179c.svg";